<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="card">
    <div class="body">
    <div class="col-lg-12">
      <exercises ref="exercise_child" :exercise="exercise" :engine="engine"></exercises>
      <br>
      <ValidationObserver ref="formValidation">
      <div class="row">
          <div class="col-md-4">
              <div class="mb-2 font-weight-bold">Configuración</div>
              <!--<div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.CALCULADORA"
                id="CALCULADORA">
                <label class="custom-control-label" for="CALCULADORA">Mostrar calculadora</label>
              </div>-->
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.SIMPLIFICAR_RESULTADO"
                id="SIMPLIFICAR_RESULTADO">
                <label class="custom-control-label" for="SIMPLIFICAR_RESULTADO">Simplificar resultado</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="configuration.REDONDEAR"
                id="REDONDEAR">
                <label class="custom-control-label" for="REDONDEAR">Redondear</label>
              </div>
          </div>
            <div class="col-md-4">
              <br/>
                Máximo decimales
                <b-form-input v-model="configuration.MAX_DECIMALES" type="number">
                </b-form-input>
            </div>
            <div class="col-md-4">
              <br/>
              Tipo aproximación<select class="form-control" v-model="configuration.APROXIMAR">
                <option value="0">Sin aproximación</option>
                <option value="1">Aproximación resultado</option>
                <option value="2">Aproximación operandos</option>
              </select>
              <div v-if="parseInt(configuration.APROXIMAR) !== 0">
                <br/>
                Nivel de aproximación
                <select class="form-control" v-model="configuration.NIVEL_APROXIMAR">
                  <option value="-5">Cienmilésimas</option>
                  <option value="-4">Diezmilésimas</option>
                  <option value="-3">Milésimas</option>
                  <option value="-2">Centésimas</option>
                  <option value="-1">Décimas</option>
                  <option value="0">Unidad</option>
                  <option value="1">Decena</option>
                  <option value="2">Centena</option>
                  <option value="3">U.millar</option>
                  <option value="4">D.millar</option>
                  <option value="5">C.millar</option>
                  <option value="6">U.millón</option>
                  <option value="7">D.millón</option>
                  <option value="8">C.millón</option>
                </select>
              </div>
            </div>
      </div>
      <br>
      <hr>
      <b-row>
        <b-col  style="text-align:center">
          <strong>Operaciones del ejercicio</strong>
          <b-button v-if="arrayEleOperation.length > 1" @click="removeArrayEleOperation()" class="btn btn-danger ml-2" size="sm">-</b-button>
          <b-button @click="addArrayEleOperation()" class="btn btn-primary ml-2" size="sm">+</b-button>
        </b-col>
      </b-row>
      <br/>
      <div>
        <div v-for="(operation, index) in arrayEleOperation" v-bind:key="index">
          <b-row style="margin-bottom: 10px">
            <b-col col lg="5">
              <b-row >
                <b-col col lg="4" style="text-align:center"><label>Cantidad</label></b-col>
                <b-col col lg="7" style="text-align:center"><label>Unidad</label></b-col>
              </b-row>
              <b-row>
                <b-col col lg="4">
                  <ValidationProvider
                    :rules="{required: true}"
                    v-slot="{ errors }">
                    <b-form-input type="text"
                      v-bind:id="'OP1C' + index"
                      v-model="arrayEleOperation[index].OP1C" />
                    <span class="validation-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
                <b-col col lg="7" class="p-0 m-0">
                  <!--<ValidationProvider rules="required" v-slot="{ errors }">-->
                    <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                      <i class="zmdi zmdi-link pointer pr-2 text-primary"
                          v-if="arrayEleOperation[index].UNIDAD1_ID !== null && arrayEleOperation[index].UNIDAD1_ID !== 0"
                          @click="openResourceWithParam('unitmath', arrayEleOperation[index].UNIDAD1_ID)"/>
                      <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="arrayEleOperation[index].UNIDAD1_ID !== null"
                        @click="cleanUnit(index, 0)"/>
                      <input type="text" v-bind:value="getTranslation(arrayEleOperation[index].UNIDAD1_TEXTO)"
                      disabled class="form-control"/>
                      <searchunitmath class="pl-2"
                        v-bind:idModal="'mdlSearchUnitMath1_'+index"
                        bButtonIcon="true"
                        v-on:selected="onSelectedUnitMath($event, index, 0)">
                      </searchunitmath>
                    </div>
                  <!--<span class="validation-error">{{ errors[0] }}</span>
                  </ValidationProvider>-->
                </b-col>
              </b-row>
              <br />
              <b-row>
                <b-col col lg="4">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <b-form-input type="text"
                      v-bind:id="'OP2C' + index"
                      v-model="arrayEleOperation[index].OP2C" />
                    <span class="validation-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
                <b-col col lg="7" class="p-0 m-0">
                  <!--<ValidationProvider rules="required" v-slot="{ errors }">-->
                    <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                      <i class="zmdi zmdi-link pointer pr-2 text-primary"
                          v-if="arrayEleOperation[index].UNIDAD2_ID !== null && arrayEleOperation[index].UNIDAD2_ID !== 0"
                          @click="openResourceWithParam('unitmath', arrayEleOperation[index].UNIDAD2_ID)"/>
                      <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="arrayEleOperation[index].UNIDAD2_ID !== null"
                        @click="cleanUnit(index, 1)"/>
                      <input type="text" v-bind:value="getTranslation(arrayEleOperation[index].UNIDAD2_TEXTO)"
                      disabled class="form-control"/>
                      <searchunitmath class="pl-2"
                      v-bind:idModal="'mdlSearchUnitMath2_'+index"
                      bButtonIcon="true"
                        v-on:selected="onSelectedUnitMath($event, index, 1)">
                      </searchunitmath>
                    </div>
                    <!--<span class="validation-error">{{ errors[0] }}</span>
                  </ValidationProvider>-->
                </b-col>
              </b-row>
              <br />
              <b-row>
                <b-col col lg="4">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <b-form-input type="text"
                      v-bind:id="'OP3C' + index"
                      v-model="arrayEleOperation[index].OP3C" />
                    <span class="validation-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
                <b-col col lg="7" class="p-0 m-0">
                  <!--<ValidationProvider rules="required" v-slot="{ errors }">-->
                    <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                      <i class="zmdi zmdi-link pointer pr-2 text-primary"
                          v-if="arrayEleOperation[index].UNIDAD3_ID !== null && arrayEleOperation[index].UNIDAD3_ID !== 0"
                          @click="openResourceWithParam('unitmath', arrayEleOperation[index].UNIDAD3_ID)"/>
                      <i class="zmdi zmdi-close-circle pointer pr-2 text-danger" v-if="arrayEleOperation[index].UNIDAD3_ID !== null"
                        @click="cleanUnit(index, 2)"/>
                      <input type="text" v-bind:value="getTranslation(arrayEleOperation[index].UNIDAD3_TEXTO)"
                      disabled class="form-control"/>
                      <searchunitmath class="pl-2"
                      v-bind:idModal="'mdlSearchUnitMath3_'+index"
                      bButtonIcon="true"
                        v-on:selected="onSelectedUnitMath($event, index, 2)">
                      </searchunitmath>
                    </div>
                    <!--<span class="validation-error">{{ errors[0] }}</span>
                  </ValidationProvider>-->
                </b-col>
              </b-row>
              <br />
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                v-model="arrayEleOperation[index].TRES_RESPUESTAS"
                id="TRES_RESPUESTAS">
                <label class="custom-control-label" for="TRES_RESPUESTAS">Respuesta triple</label>
              </div>
             </b-col>
            <b-col col lg="7">
              <b-row>
                <b-col col lg="12">
                  Enunciado
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                      <i class="zmdi zmdi-link pointer pr-2 text-primary"
                          v-if="arrayEleOperation[index].ENUNCIADOS_SIMPLES_ID !== null && arrayEleOperation[index].ENUNCIADOS_SIMPLES_ID !== 0"
                          @click="openResourceWithParam('statementsimple', arrayEleOperation[index].ENUNCIADOS_SIMPLES_ID)"/>
                      <input type="text" v-model="arrayEleOperation[index].ENUNCIADOS_SIMPLES_TEXTO"
                        disabled class="form-control" />
                      <searchstatements class="pl-2" v-bind:idModal="'mdlSearchEnunciado_'+index"
                        v-on:selected="onEnunciadoProblem($event, index)">
                      </searchstatements>
                    </div>
                    <span class="validation-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
                <b-col col lg="12" class="mt-4">
                  <label>Plantilla</label>
                    <div class="col-md-12 d-inline-flex align-items-center p-0 m-0">
                      <i class="zmdi zmdi-link pointer pr-2 text-primary"
                          v-if="arrayEleOperation[index].PLANTILLAS_ID !== null && arrayEleOperation[index].PLANTILLAS_ID !== 0"
                          @click="openResourceWithParam('templates', arrayEleOperation[index].PLANTILLAS_ID)"/>
                      <b-form-textarea
                        id="textarea"
                        disabled class="form-control"
                        v-bind:value="getTranslation(arrayEleOperation[index].PLANTILLA_TEXTO)"
                        placeholder="Plantilla..."
                        rows="5"
                        max-rows="5"
                        :readonly=true >
                      </b-form-textarea>
                    </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <hr/>
        </div>
      </div>
      <br>
      <b-row>
        <b-col class="text-center">
          <button v-on:click="saveStorage" :disabled="arrayEleOperation.length < 1" class="btn btn-info btn-lg">
          Guardar
        </button>
        </b-col>
      </b-row>
      </ValidationObserver>
    </div>
    </div>
  </div>
</div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, regex } from 'vee-validate/dist/rules';
import exercises from '../../exercises/exercise.vue';
import engineMixin from '../../../../mixins/engine';
import searchunitmath from '../../units/SearchUnitmath.vue';
import searchstatements from '../../statements/SearchStatementSimples.vue';
import translationMixin from '../../../../mixins/translation';

extend('required', {
  ...required,
  message: 'Campo obligatorio.',
});
/* regex: /^[0-9]*\|[0-9]+$/ */
extend('regex', {
  ...regex,
  message: 'Formato valido: 1|2.',
});

export default {
  props: {
    engine: Number,
    exercise: Object,
    type: String,
  },
  mixins: [engineMixin, translationMixin],
  components: {
    exercises,
    ValidationProvider,
    ValidationObserver,
    searchstatements,
    searchunitmath,
  },
  data() {
    return {
      selectedNumOpertion: 1,
      arrayEleOperation: [],
      // Mapear con los campos de la tabla PROBSIMPLES_CONF
      configuration: {
        ID: -1,
        CALCULADORA: false,
        SIMPLIFICAR_RESULTADO: true,
        MAX_DECIMALES: 2,
        REDONDEAR: true, //
        APROXIMAR: 0, // [0] Sin aproximación [1] Aproximación resultado [2] Aproximación operandos
        NIVEL_APROXIMAR: 2,
        EJERCICIOS_ID: -1, //
      },
    };
  },
  methods: {
    removeArrayEleOperation() {
      this.arrayEleOperation.pop();
    },
    addArrayEleOperation() {
      this.arrayEleOperation.push({
        POSICION: this.arrayEleOperation.length + 1,
        OP1C: null,
        OP2C: null,
        OP3C: null,
        UNIDAD1_ID: null,
        UNIDAD1_TEXTO: [],
        UNIDAD2_ID: null,
        UNIDAD2_TEXTO: [],
        UNIDAD3_ID: null,
        UNIDAD3_TEXTO: [],
        TRES_RESPUESTAS: null,
        PLANTILLAS_ID: null,
        PLANTILLA_TEXTO: [],
        ENUNCIADOS_SIMPLES_ID: null,
        ENUNCIADOS_SIMPLES_TEXTO: null,
      });
    },
    async getMotorData(id) {
      this.loading = true;

      try {
        const response = await this.axios.get('problemsimples/getproblemsimples', {
          params: {
            ejercicios_id: id,
          },
        });
        this.configuration = response.data.config;
        response.data.elements.forEach((element) => {
          this.arrayEleOperation.push({
            POSICION: element.POSICION,
            OP1C: element.OP1C,
            OP2C: element.OP2C,
            OP3C: element.OP3C,
            UNIDAD1_ID: element.UNIDAD1_ID,
            UNIDAD1_TEXTO: element.UNIDAD1_TEXTO,
            UNIDAD2_ID: element.UNIDAD2_ID,
            UNIDAD2_TEXTO: element.UNIDAD2_TEXTO,
            UNIDAD3_ID: element.UNIDAD3_ID,
            UNIDAD3_TEXTO: element.UNIDAD3_TEXTO,
            TRES_RESPUESTAS: element.TRES_RESPUESTAS,
            PLANTILLAS_ID: element.PLANTILLAS_ID,
            PLANTILLA_TEXTO: element.PLANTILLA_TEXTO,
            ENUNCIADOS_SIMPLES_ID: element.ENUNCIADOS_SIMPLES_ID,
            ENUNCIADOS_SIMPLES_TEXTO: element.ENUNCIADOS_SIMPLES_TEXTO,
          });
        });
      } catch (e) {
        this.$toasted.show('Ocurrió un error al leer el motor', { type: 'warning' });
      }

      this.loading = false;
    },
    /**
    * @method onEnunciadProblem
    * @description Al buscar un enunciado
    */
    onEnunciadoProblem(itemSelected, idOperation) {
      this.arrayEleOperation[idOperation].ENUNCIADOS_SIMPLES_TEXTO = itemSelected.NOMBRE;
      this.arrayEleOperation[idOperation].ENUNCIADOS_SIMPLES_ID = itemSelected.ID;

      this.arrayEleOperation[idOperation].PLANTILLAS_ID = itemSelected.PLANTILLAS_ID;
      this.arrayEleOperation[idOperation].PLANTILLA_TEXTO = itemSelected.PLANTILLA;

      this.$root.$emit('bv::hide::modal', `mdlSearchEnunciado_${idOperation}`);
    },
    cleanUnit(posicion, id) {
      switch (id) {
        case 0:
          this.arrayEleOperation[posicion].UNIDAD1_ID = null;
          this.arrayEleOperation[posicion].UNIDAD1_TEXTO = [];
          break;
        case 1:
          this.arrayEleOperation[posicion].UNIDAD2_ID = null;
          this.arrayEleOperation[posicion].UNIDAD2_TEXTO = [];
          break;
        case 2:
          this.arrayEleOperation[posicion].UNIDAD3_ID = null;
          this.arrayEleOperation[posicion].UNIDAD3_TEXTO = [];
          break;
        default:
          break;
      }
    },
    /**
     * Guardar el Id de Unidad por Elemento
     */
    onSelectedUnitMath(itemSelected, posicion, id) {
      switch (id) {
        case 0:
          this.arrayEleOperation[posicion].UNIDAD1_ID = itemSelected.ID;
          this.arrayEleOperation[posicion].UNIDAD1_TEXTO = itemSelected.TEXTO_SINGULAR;
          this.$root.$emit('bv::hide::modal', `mdlSearchUnitMath1_${posicion}`);
          break;
        case 1:
          this.arrayEleOperation[posicion].UNIDAD2_ID = itemSelected.ID;
          this.arrayEleOperation[posicion].UNIDAD2_TEXTO = itemSelected.TEXTO_SINGULAR;
          this.$root.$emit('bv::hide::modal', `mdlSearchUnitMath2_${posicion}`);
          break;
        case 2:
          this.arrayEleOperation[posicion].UNIDAD3_ID = itemSelected.ID;
          this.arrayEleOperation[posicion].UNIDAD3_TEXTO = itemSelected.TEXTO_SINGULAR;
          this.$root.$emit('bv::hide::modal', `mdlSearchUnitMath3_${posicion}`);
          break;
        default:
          break;
      }
    },
  },
  async mounted() {
    if (this.exercise !== null && (this.exercise.ID !== null && this.exercise.ID !== undefined)) {
      await this.getMotorData(this.exercise.ID);
    }
    // Read from storage data
    this.readFromStorage(this.type);
    this.updatedNumOperation();
  },
};
</script>
